import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedComponentsModule } from '../../shared/shared-components.module';

import { SearchComponent } from './search.component';
import { SearchResultCardComponent } from './components/search-result-card/search-result-card.component';
import { MainModule } from '../main/main.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BannersComponent } from './components/banners/banners.component';
import { AnywhereCareComponent } from './components/banners/anywhere-care/anywhere-care.component';
import { EdermatologyComponent } from './components/banners/edermatology/edermatology.component';
import { BehavioralHealthComponent } from './components/banners/behavioral-health/behavioral-health.component';

@NgModule({
  imports: [
    CommonModule,
    MainModule,
    FormsModule,
    SharedComponentsModule,
    BrowserAnimationsModule
  ],
  declarations: [
    SearchComponent,
    SearchResultCardComponent,
    BannersComponent,
    AnywhereCareComponent,
    BehavioralHealthComponent,
    EdermatologyComponent
  ],
  exports: [
    SearchComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class SearchModule { }
